"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.bmFormInfoFactory = exports.BmFormDefaultInfo = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _entries = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/entries"));

var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _formFactory = require("../form-engine/form-factory");

var _itemFactory = require("../item-engine/item-factory");

var _bmFormValues = require("../../bm-form-values");

var BmFormDefaultInfo = /*#__PURE__*/function (_bmValuedGroup) {
  (0, _inherits2.default)(BmFormDefaultInfo, _bmValuedGroup);

  var _super = (0, _createSuper2.default)(BmFormDefaultInfo);

  function BmFormDefaultInfo(info, parent, layoutInfo, values) {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, BmFormDefaultInfo);
    _this = _super.call(this, info, parent);
    _this.type = 'form';
    _this.options = void 0;
    _this.layout = void 0;
    _this.hideErrors = false;
    _this.previousHideErrors = null;

    if (layoutInfo) {
      var formLayout = layoutInfo.formLayout,
          layout = (0, _objectWithoutProperties2.default)(layoutInfo, ["formLayout"]);
      _this.layout = layout;
    } else {
      _this.layout = null;
    }

    var items = (0, _reduce.default)(_context = (0, _entries.default)(info.options.items || {})).call(_context, function (acc, _ref) {
      var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
          itemName = _ref2[0],
          itemInfo = _ref2[1];

      var subLayout = layoutInfo && layoutInfo.formLayout ? layoutInfo.formLayout[itemName] : undefined;
      var subValues = (values || {})[itemName];
      acc[itemName] = (0, _itemFactory.createItem)(itemInfo, (0, _assertThisInitialized2.default)(_this), subLayout, subValues);
      return acc;
    }, {});
    _this.options = {
      items: items
    };
    return _this;
  }

  return BmFormDefaultInfo;
}((0, _bmFormValues.bmValuedGroup)(_formFactory.BmFormInfo));

exports.BmFormDefaultInfo = BmFormDefaultInfo;

var bmFormInfoFactory = function bmFormInfoFactory(info, parent, layout, values) {
  return new BmFormDefaultInfo(info, parent, layout, values);
};

exports.bmFormInfoFactory = bmFormInfoFactory;
